import React, { useEffect } from "react";
import { Table } from "flowbite-react";
import { useFileManager } from "../context/FileMangerContextHelper";
const RecentFilesTable = () => {
  const { recentFiles, getRecentFiles } = useFileManager();

  useEffect(() => {
    getRecentFiles();
  }, [getRecentFiles]);

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  return recentFiles.length > 0 ? (
    <Table hoverable>
      <Table.Head>
        <Table.HeadCell>File Name</Table.HeadCell>
        <Table.HeadCell>File Type</Table.HeadCell>
        <Table.HeadCell>File Size</Table.HeadCell>
        <Table.HeadCell>Date Uploaded</Table.HeadCell>
        <Table.HeadCell>
          <span className="sr-only">Open</span>
        </Table.HeadCell>
      </Table.Head>
      <Table.Body className="divide-y">
        {recentFiles.map((file) => {
          return (
            <Table.Row
              key={file.id}
              className="bg-white dark:border-gray-700 dark:bg-gray-800"
            >
              <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                {file.file_name}
              </Table.Cell>
              <Table.Cell>{file.file_type}</Table.Cell>
              <Table.Cell>{file.file_size}</Table.Cell>
              <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                {formatDate(file.uploaded_at)}
              </Table.Cell>
              <Table.Cell>
                <a
                  href={file.file}
                  target="_blank"
                  className="font-medium text-cyan-600 hover:underline dark:text-cyan-500"
                >
                  Open
                </a>
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  ) : (
    <div className="flex flex-row items-center justify-center overflow-hidden pt-20 md:pt-40 font-medium text-lg">
      No Files Yet
    </div>
  );
};

export default RecentFilesTable;
